module.exports = __webpack_public_path__ + "img/icon-style-normal.8df976d.png";